import React from 'react';
import { InputText } from 'primereact/inputtext';
import { FormField } from '../../FormField/FormField';

interface Props {
  labelTitle: string;
  elementId: string;
  placeholder: string;
  value: string | undefined;
  onChange: (value: string) => void;
  isModifying: boolean;
  invalid?: boolean;
}

/** A one-line text of the reservation, such as its custom name or its title. */
export const ReservationTextField = ({ labelTitle, elementId, placeholder, value, onChange, isModifying, invalid }: Props) => (
  <FormField labelTitle={labelTitle} elementId={elementId} fullWidth>
    {isModifying ? (
      <InputText
        id={elementId}
        invalid={invalid}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    ) : (
      <p>{value}</p>
    )}
  </FormField>
);
